window.i18n_es = {
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Múltiples Sesiones Detectadas",
      "your_account_is_active_in_another_window": "Tu cuenta está activa en otra ventana o dispositivo. Cierra la otra sesión para continuar usando AlphaX Tuning Sim.",
      "alphax_tuning_simulator": "Simulador de Tuning AlphaX",
      "garage_tuning": "Garaje (Tuning)",
      "dynamometer": "Dinamómetro",
      "drag_strip": "Pista de Aceleración",
      "leaderboards": "Tablas de Clasificación",
      "login": "iniciar sesión",
      "import_tune": "IMPORTAR MAPA",
      "export_tune": "Exportar Mapa",
      "start_engine": "ARRANCAR MOTOR",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Estado:",
      "off": "OFF",
      "map": "MAP:",
      "101_kpa": "101 kPa",
      "boost": "Boost:",
      "00_psi": "0.0 psi",
      "config": "Config:",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS:",
      "0": "0%",
      "timing": "Avance:",
      "knk_retard": "Retraso por Detonación:",
      "knock_count": "Conteo de Detonación:",
      "inj_pw_cyl_1": "Pulso Iny. (Cil 1):",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Intake:",
      "vvt_exhaust": "VVT Exhaust:",
      "coolant_temp": "Temp. Refrigerante:",
      "_": "+ / - / *",
      "ethanol": "Etanol:",
      "fuel_rail": "Riel de Combustible:",
      "_psi": "-- PSI",
      "stft": "STFT:",
      "pump_load": "Carga de Bomba:",
      "battery": "Batería:",
      "125_v": "12.5 V",
      "max_pedal_tps": "TPS Máximo del Pedal",
      "100": "100%",
      "throttle_hold": "Mantener Acelerador",
      "pedal": "PEDAL",
      "ecu_flags": "BANDERAS ECU:",
      "engine_limits": "Límites del Motor",
      "trigger": "Disparador",
      "adv_uo": "¡Solo usuarios avanzados!",
      "smart_alternator": "Alternador Inteligente",
      "axis_wizard": "Asistente de Ejes",
      "ve_table": "Tabla VE",
      "target_afr_table": "Tabla AFR Objetivo",
      "fuel_settings": "Ajustes de Combustible",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Combustible Lazo Cerrado",
      "accel_enrichment": "Enriquecimiento Acel.",
      "ignition_advance": "Avance de Encendido",
      "ignition_settings": "Ajustes de Encendido",
      "knock_control": "Control de Detonación",
      "vvt_intake_target": "Objetivo VVT Admisión",
      "vvt_exhaust_target": "Objetivo VVT Escape",
      "vvt_vtec_settings": "Ajustes VVT / VTEC",
      "idle": "Ralentí",
      "cranking": "Arranque",
      "upgrades_mods": "Mejoras y Mods",
      "nitrous_system": "Sistema de Nitro",
      "wastegate_duty_table": "Tabla Ciclo Wastegate",
      "cl_boost_target": "Objetivo Boost Lazo Cerrado",
      "launch_control": "Control de Salida",
      "simulation_settings": "Ajustes de Simulación",
      "simple": "SIMPLE",
      "adv": "ADV",
      "buy_advanced_mode": "¡Comprar Modo Avanzado!",
      "log_off": "LOG OFF",
      "selection_tools": "Herramientas de Selección:",
      "interp_x_row": "Interp X (Fila)",
      "interp_y_col": "Interp Y (Col)",
      "interp_2d_area": "Interp 2D (Área)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "Tabla VE (Carga vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Números más altos = más combustible. Ajustar para alcanzar el AFR objetivo.",
      "target_afr_table_load_vs_rpm": "Tabla AFR Objetivo (Carga vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Relación Aire/Combustible comandada. Parte fundamental de la ecuación de Densidad de Velocidad.",
      "fuel_injector_settings": "Ajustes de Combustible e Inyectores",
      "injector_size_ccmin": "Tamaño del Inyector (cc/min)",
      "injector_reference_pressure_kpa": "Presión de Referencia del Inyector (kPa)",
      "dead_time_ms_by_v": "Tiempo Muerto (ms por V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Multiplier at each IAT. 1.0 = no change, 0.9 = −10%, 1.1 = +10%.",
      "ect_fuel_enrichment_": "ECT Fuel Enrichment (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Fuel multiplier on cold start. 1.0 = no correction at operating temp.",
      "fuel_octane": "Octanaje del Combustible",
      "87_aki_regular": "87 AKI (Regular)",
      "91_aki_premium": "91 AKI (Premium)",
      "93_aki_premium": "93 AKI (Premium+)",
      "100_aki_race_gas": "100 AKI (Race Gas)",
      "104_aki_race_gas": "104 AKI (Race Gas)",
      "116_aki_methanolrace": "116+ AKI (Methanol/Race)",
      "display_afr_as_lambda_3_decimals": "Display AFR as Lambda (3 decimals)",
      "enable_fuel_pressure_model": "Enable Fuel Pressure Model",
      "base_fuel_pressure_psi": "Base Fuel Pressure (PSI)",
      "fuel_system_type": "Fuel System Type",
      "return_style_rising_rate": "Return Style (rising rate)",
      "returnless_fixed_pressure": "Returnless (fixed pressure)",
      "return_style_rail_rises_11_with_boost_in": "Return style: rail rises 1:1 with boost — injector differential stays constant. Returnless: fixed rail pressure, injector flow drops under boost.",
      "apply_settings": "Apply Settings",
      "ignition_timing_table_load_vs_rpm": "Tabla de Avance de Encendido (Carga vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "flex_fuel_sensor_simulation": "Flex Fuel Sensor Simulation",
      "moving_this_slider_simulates_adding_etha": "Moving this slider simulates adding ethanol to the fuel tank. The ECU will automatically adjust the base fuel mass requirement to maintain your commanded AFR (stoich scaling). You must use the compensation tables below to unlock the performance benefits (timing/boost) and final VE tweaks.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Enable Flex Fuel Tuning (Populate Flex Tables on Perfect Export)",
      "ethanol_content_": "Ethanol Content (%)",
      "apply_content": "Apply Content",
      "flex_fuel_ve_adder_": "Flex Fuel VE Adder (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Blend Curve (0-100%) x Base Map (MAP vs RPM)",
      "flex_fuel_afr_offset": "Flex Fuel AFR Offset",
      "flex_fuel_timing_adder_deg": "Flex Fuel Timing Adder (deg)",
      "flex_fuel_boost_duty_adder_": "Flex Fuel Boost Duty Adder (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Blend Curve (0-100%) x Base Map (TPS vs RPM)",
      "closed_loop_fuel_stft": "Closed-Loop Fuel (STFT)",
      "enable_closed_loop_correction": "Enable Closed-Loop Correction",
      "deadband_": "Deadband (%)",
      "lambda_error_within_this_band_is_ignored": "Lambda error within this band is ignored. 2% = no correction if actual AFR is within ±2% of target.",
      "tps_lt_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "time_constant_s": "Time Constant (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Min Correction (%)",
      "max_correction_": "Max Correction (%)",
      "part_throttle_cruise": "(part throttle / cruise)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS &gt; 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Acceleration Enrichment",
      "corrects_fueling_during_rapid_throttle_o": "Corrects fueling during rapid throttle openings. MAP lag is simulated when any mode is active (0.3s delay at idle, fading to instant above 2000 RPM).",
      "mode": "MODE:",
      "none_disabled": "None (Disabled)",
      "ms_adder": "MS Adder",
      "map_prediction": "MAP Prediction",
      "accel_time_s": "Accel Time (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Decay Rate",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Ignition System Mode",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Distributor (Single Coil)",
      "wasted_spark_n2_coils": "Wasted Spark (N/2 Coils)",
      "fully_sequential_cop": "Fully Sequential / COP",
      "spark_plug_gap_inches": "Spark Plug Gap (inches)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Degrees of retard at each IAT. 0 = no retard.",
      "coil_dwell_time_ms_by_battery_v": "Coil Dwell Time (ms by Battery V)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Knock Sensor Spectrogram",
      "pause": "PAUSE",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "_25s": "-2.5s",
      "now": "Now",
      "knock_threshold_db_vs_rpm": "Knock Threshold (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Control Parameters",
      "enable_knock_control": "Enable Knock Control",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Attack (deg/event)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Max Retard (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Recovery Rate (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "Min TPS to Engage (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "Min MAP to Engage (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Knock Control Frequency Calibration Mode",
      "enter_calibration_mode": "Enter Calibration Mode",
      "identify_the_engines_natural_knock_reson": "Identify the engine's natural knock resonant frequency using the 3D spectrogram below. Start the engine and\n                                induce knock (over-advance timing or exceed octane limit). A bright streak will appear at a specific frequency\n                                on the waterfall — that is the engine's resonance point. Align the center frequency marker to that streak,\n                                then confirm calibration to unlock Knock Control.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Center Freq (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Temp Timing Adder",
      "_for": "° for",
      "s": "s",
      "apply": "Apply",
      "confirm_calibration": "Confirm Calibration",
      "recalibrate": "Recalibrate",
      "nitrous_oxide_system": "Nitrous Oxide System",
      "upgrades_amp_mods": "Upgrades &amp; Mods",
      "n2o_jet_size_thousandths_in": "N2O Jet Size (thousandths in.)",
      "estimated_power": "Estimated Power",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Fuel Jet Size (thousandths in.)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Activation Mode",
      "button_switch": "Button / Switch",
      "ecu_control": "ECU Control",
      "ecu_control_parameters": "ECU Control Parameters",
      "min_tps_": "Min TPS (%)",
      "min_rpm": "Min RPM",
      "max_rpm": "Max RPM",
      "max_map_kpa": "Max MAP (kPa)",
      "afr_safety_cut_lean": "AFR Safety Cut (lean)",
      "fuel_ve_comp_": "Fuel VE Comp. (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Timing Retard (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Apply Nitrous Settings",
      "vvt_intake_advance_target_load_vs_rpm": "VVT Intake Advance Target (Load vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "VVT Exhaust Retard Target (Load vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Variable Valve Lift (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "VVL / High Cam Switch (RPM)",
      "vvl_high_cam_min_tps_": "VVL / High Cam Min TPS (%)",
      "vvl_fuel_adder_ve_": "VVL Fuel Adder (VE %)",
      "vvl_timing_adder_": "VVL Timing Adder (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Closed Loop PID Control",
      "enable_closed_loop_pid_control": "Enable Closed Loop PID Control",
      "proportional_kp": "Proportional (Kp)",
      "integral_ki": "Integral (Ki)",
      "derivative_kd": "Derivative (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Wastegate Duty Table (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "CL Boost Target Table (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Límite de Rev (RPM)",
      "rev_limit_hysteresis_rpm": "Rev Limit Hysteresis (RPM)",
      "fuel_cut": "Fuel Cut",
      "spark_cut": "Spark Cut",
      "enable_decel_fuel_cut": "Enable Decel Fuel Cut",
      "cut_delay_sec": "Cut Delay (Sec)",
      "boost_protection": "Boost Protection",
      "boost_cut_psi": "Boost Cut (psi)",
      "hysteresis_psi": "Hysteresis (psi)",
      "trigger_calibration": "Trigger Calibration",
      "timing_light_mode": "Timing Light Mode",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Enable Smart Alternator",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "P Gain",
      "i_gain": "I Gain",
      "d_gain": "D Gain",
      "alternator_duty": "Alternator Duty:",
      "na": "N/A",
      "axis_setup_wizard": "Axis Setup Wizard",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "Base RPM",
      "base_kpa_min_load": "Base kPa (min load)",
      "max_kpa": "Max kPa",
      "apply_axis_wizard": "Apply Axis Wizard",
      "reset_to_default": "Reset to Default",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Idle Settings",
      "maximum_idle_tps": "Maximum Idle TPS%",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Idle Control RPM Upper Limit",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Target Idle RPM vs Coolant Temp",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Idle Duty vs Coolant Temp (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Closed Loop Idle Ignition",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Cranking / Starting",
      "base_ve": "Base VE",
      "max_crank_rpm": "Max Crank RPM",
      "decay_s": "Decay (s)",
      "crank_time_s": "Crank Time (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Post-Crank Enrichment vs Coolant Temp (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Post-Crank Decay Cycles",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Vehicle Upgrades",
      "export_mod_list": "EXPORT MOD LIST",
      "import_mod_list": "IMPORT MOD LIST",
      "mod_collection": "Mod Collection",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Launch Control / Two-Step",
      "enable_launch_control": "Enable Launch Control",
      "launch_rpm": "Launch RPM",
      "hysteresis_rpm": "Hysteresis (RPM)",
      "window_size_rpm": "Window Size (RPM)",
      "cut_type": "Cut Type",
      "ignition_cut": "Ignition Cut",
      "both_hard_cut": "Both (Hard Cut)",
      "window_start_timing_deg": "Window Start Timing (deg)",
      "limit_timing_deg_absolute": "Limit Timing (deg absolute)",
      "fuel_adder_afr_": "Fuel Adder (AFR %)",
      "activate_two_step_mode_switch": "Activate Two-Step Mode Switch",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Unit System",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Modo de Visualización de Presión",
      "absolute": "Absoluta",
      "gauge": "Manométrica",
      "switches_pressure_on_y_axes_and_gauges": "Cambia la presión en los ejes Y y medidores entre presión absoluta y manométrica. Los cálculos internos siempre usan kPa absoluto.",
      "ambient_temperature_f": "Ambient Temperature (°F)",
      "ambient_temperature_c": "Ambient Temperature (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Barometric Pressure (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Relative Humidity (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Simulación de Temperatura de Refrigerante",
      "enable_ect_simulation": "Habilitar Simulación ECT",
      "when_enabled_engine_starts_cold_at_ambie": "Cuando está activo, el motor arranca frío a temperatura ambiente y se calienta hasta 90 °C. Desactivado = ECT bloqueado a 90 °C.",
      "o2_sensor_simulation": "Simulación de Sensor O2",
      "enable_o2_transport_delay_amp_combustion": "Habilitar Retardo de Transporte O2 y Ruido de Combustión",
      "adds_exhaust_transport_delay_to_afr_disp": "Añade retardo de transporte de escape a la lectura de AFR (300ms en ralentí, 0ms a 3500 RPM) y varianza de combustión de ±3% en la física a bajas RPM.",
      "starter_mode": "Starter Mode",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Indicador de Detonación",
      "show_knock_event_indicator_overlay": "Mostrar indicador de evento de detonación",
      "floating_counter_shown_in_all_views_when": "Contador flotante visible en todas las vistas cuando el motor detona. En Modo Avanzado, usa la pestaña Control de Detonación.",
      "transmission_selection": "Transmission Selection",
      "export": "EXPORT",
      "custom_ratios": "Custom Ratios",
      "final_drive_ratio": "FINAL DRIVE RATIO",
      "gear_1": "GEAR 1",
      "gear_2": "GEAR 2",
      "gear_3": "GEAR 3",
      "gear_4": "GEAR 4",
      "gear_5": "GEAR 5",
      "gear_6": "GEAR 6",
      "gear_7": "GEAR 7",
      "gear_8": "GEAR 8",
      "gear_9": "GEAR 9",
      "gear_10": "GEAR 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Apply Simulation Settings",
      "virtual_dynamometer": "Dinamómetro Virtual",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG OFF",
      "set_as_reference": "FIJAR COMO REFERENCIA",
      "hold_n2o": "MANTENER N2O",
      "smoothing": "SMOOTHING:",
      "0_raw": "0 (Raw)",
      "5_max": "5 (Max)",
      "correction": "CORRECTION:",
      "none": "None",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Load Dyno",
      "rpm_lock": "RPM Lock",
      "dynojet": "Dynojet",
      "rpms": "RPM/S:",
      "target_rpm": "TARGET RPM:",
      "afr_guideline": "AFR GUIDELINE:",
      "start_rpm": "START RPM:",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Leaderboard Display Name",
      "submit_to_leaderboard": "Submit to Leaderboard",
      "clutch_0": "CLUTCH: 0%",
      "run": "RUN",
      "launch": "LAUNCH",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Mile",
      "1000ft": "1000ft",
      "14_mile": "1/4 Mile",
      "reaction_time": "Reaction Time",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Sim Config",
      "weight_lbs": "Weight (lbs)",
      "shift_rpm": "Shift RPM",
      "shift_delay_s": "Shift Delay (s)",
      "tires": "Tires",
      "economy": "Economy",
      "street": "Street",
      "summer": "Summer",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Drag Slicks",
      "clutch_slip_s": "Clutch Slip (s)",
      "lb_class": "LB Class",
      "run_controls": "Run Controls",
      "start_1x": "START (1x)",
      "ff_3x": "FF (3x)",
      "instant": "INSTANT",
      "shift_up": "SHIFT UP",
      "abort": "ABORT",
      "n2o": "N2O",
      "manual_mode": "Manual Mode",
      "no_shift_on_slip": "No Shift on Slip",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Requirement:",
      "logged_in": "logged in",
      "advanced_mode": "Advanced Mode",
      "default_vehicle_weight": "Default Vehicle Weight",
      "01s_shift_delay": "0.1s Shift Delay",
      "engine": "Engine",
      "category": "Category",
      "stock_economy": "Stock — Economy",
      "stock_street": "Stock — Street",
      "stock_summer": "Stock — Summer",
      "stock_drag_radials": "Stock — Drag Radials",
      "stock_drag_slicks": "Stock — Drag Slicks",
      "mod_na_economy": "Mod N/A — Economy",
      "mod_na_street": "Mod N/A — Street",
      "mod_na_summer": "Mod N/A — Summer",
      "mod_na_drag_radials": "Mod N/A — Drag Radials",
      "mod_na_drag_slicks": "Mod N/A — Drag Slicks",
      "power_adder_economy": "Power Adder — Economy",
      "power_adder_street": "Power Adder — Street",
      "power_adder_summer": "Power Adder — Summer",
      "power_adder_drag_radials": "Power Adder — Drag Radials",
      "power_adder_drag_slicks": "Power Adder — Drag Slicks",
      "super_pa_economy": "Super PA — Economy",
      "super_pa_street": "Super PA — Street",
      "super_pa_summer": "Super PA — Summer",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Drag Slicks",
      "search": "Search",
      "knock_detected": "Detonación Detectada",
      "0_events": "0 eventos",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "&times;",
      "simple_mode_vs_advanced_mode": "Modo Simple vs Modo Avanzado",
      "free": "(Gratis)",
      "purchased": "(Comprado)",
      "click_here_to_get_advanced_mode_": "Click Here to get Advanced Mode →",
      "extra_engines_amp_mods": "Extra Engines &amp; Mods",
      "click_here_to_browse_engines_": "Click Here to browse Engines →",
      "click_here_to_browse_mods_": "Click Here to browse Mods →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "AlphaX account",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Controles →",
      "space": "Espacio",
      "click_drag": "Click / Arrastrar",
      "click_cell": "Click en celda",
      "ctrlz_y": "Ctrl+Z / Y",
      "table_keyboard_shortcuts": "Atajos de Teclado de la Tabla",
      "arrows": "Flechas",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Ctrl+C / V",
      "datalogging": "Registro de Datos",
      "basic_tuning_tips": "Consejos Básicos de Tuning",
      "ignition_timing": "Avance de Encendido",
      "target_afr": "AFR Objetivo",
      "map_axis": "Eje MAP",
      "_back": "← Back",
      "controls_": "Controls →",
      "got_it_": "Got it! ✓",
      "run_category_check": "Run Category Check",
      "close": "Close",
      "save_your_tune": "Guardar tu Mapa",
      "you_have_unsaved_tuning_changes": "Tienes cambios de tuning sin guardar.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Dismiss",
      "keep_adjusting": "Keep Adjusting",
      "timing_is_correct_": "Timing is Correct ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Carga el motor dinámicamente para realizar un barrido en tiempo real.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Los registros incluyen RPM, MAP, AFR, avance, VE, torque, boost y más",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Grados antes del Punto Muerto Superior. Demasiado avance causa detonación.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "INICIAR PRUEBA DYNO",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "✓ Tablas de VE, Avance y AFR Objetivo",
      "10003_flex_fuel_tables_e85_physics": "✓ Tablas Flex Fuel y física de E85",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Disponible en modos Garaje, Dyno y Pista",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "✓ Daño de motor y fallos aleatorios",
      "timing_is_correct": "El Tiempo es Correcto ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "✓ Control de salida y two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "✓ Detección y retraso por detonación",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "✓ Todo lo del modo Simple, más:",
      "10003_accel_enrichment_ms_map": "✓ Enriquecimiento por aceleración (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "✓ Simulación de Dyno y Pista",
      "10003_coil_dwell_misfire_physics": "✓ Física de fallos por carga de bobina",
      "10003_vvt_vvl_cam_control": "✓ Control de levas VVT y VVL",
      "10003_closed_loop_boost_control": "✓ Control de boost de lazo cerrado",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "✓ Registro de datos (exportación CSV)",
      "10003_o2_sensor_delay_modeling": "✓ Modelado de retraso de sensor O2",
      "10003_drag_racing_leaderboards": "✓ Tablas de clasificación de aceleración",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "✓ AFR de lazo cerrado básico",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "✓ Importación / Exportación de mapas",
      "10003_smart_alternator_pid": "✓ PID de alternador inteligente",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "✓ Modelo de presión de combustible",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "✓ PID de encendido en ralentí",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "✓ Corte de combustible en desaceleración",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PICO BOOST:",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "ORDEN DE ENCENDIDO",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVO",
      "fuel_air": "Combustible y Aire",
      "vvt_cams": "VVT y Levas",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PICO HP:",
      "peak_tq": "PICO TQ:",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Encendido",
      "advanced": "Avanzado",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "¡Entendido! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Configuración",
      "player": "Player",
      "click": "Click",
      "back": "← Atrás",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "SPEED",
      "accel": "ACCEL",
      "slip": "SLIP!",
      "time": "TIME",
      "gear": "GEAR",
      "mods": "Mods",
      "tdc": "TDC",
      "mph": "MPH",
      "mod_intake": "Admisión",
      "mod_intake_manifold": "Colector de Admisión",
      "mod_exhaust_manifold": "Colector de Escape",
      "mod_exhaust": "Escape",
      "mod_port_and_polish": "Porteo y Pulido",
      "mod_turbocharger": "Turbocompresor",
      "mod_supercharger": "Sobrealimentador",
      "mod_camshaft": "Árbol de Levas",
      "mod_pistons": "Pistones",
      "mod_rods": "Bielas",
      "mod_clutch": "Embrague",
      "mod_intercooler": "Intercooler",
      "mod_fuel_pump": "Bomba de Combustible",
      "mod_fuel_injector": "Inyector de Combustible",
      "stock_none": "Original / Ninguno",
      "dry_shot_system": "Sistema Dry Shot",
      "wet_shot_system": "Sistema Wet Shot",
      "buy_nitrous_kit": "¡Comprar Kit de Nitro!",
      "mod_settings": "Ajustes de Mods",
      "wastegate_spring_psi": "Resorte Wastegate (psi)",
      "wastegate_spring_kpa": "Resorte Wastegate (kPa)",
      "map_axes_scale_help": "Los ejes MAP escalan a 2× la presión del resorte.",
      "closed_loop_boost": "Boost de Lazo Cerrado",
      "pulley_ratio": "Relación de Polea (SC/Eng)",
      "bypass_threshold": "Umbral de Bypass (%)",
      "max_sc_rpm": "RPM Máx SC:",
      "twin_turbo_setup": "Configuración Twin Turbo",
      "twin_turbo_help": "(×1.9 flujo aire, ~½× velocidad spool)",
      "custom_transmission": "Transmisión Personalizada",
      "applied": "¡Aplicado!",
      "stop_engine": "APAGAR MOTOR",
      "flooded": "AHOGADO",
      "no_start_trigger": "NO ARRANCA: ÁNGULO DISPARADOR",
      "no_start_lean": "NO ARRANCA: MEZCLA POBRE",
      "stalled": "APAGADO",
      "stalled_rpm": "APAGADO: RPM bajó de velocidad de arranque.",
      "stalled_battery": "APAGADO: Voltaje de batería críticamente bajo (8 V).",
      "submitting": "Enviando...",
      "submitted": "¡Enviado!",
      "error_retry": "Error (Reintentar)",
      "on": "ON",
      "abort_dyno_pull": "ABORTAR PRUEBA DYNO",
      "holding_rpm": "MANTENIENDO RPM...",
      "stabilizing": "ESTABILIZANDO..."
    }
  }
};